"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../../../type/entity");
function getToCompleteContentIds(content, newStates, previousCourseCompletionStatus, completedContentIds) {
    const rootContentId = content._id;
    const contentNewStates = newStates.filter(state => state.rootContentId_contentId.indexOf(rootContentId) === 0);
    // filtering incompleted cardIds
    const incompleteCardContentIds = contentNewStates
        .filter(state => state.contentType === entity_1.ContentType.ASSIGNMENT_CARD ||
        state.contentType === entity_1.ContentType.LEARNING_CARD ||
        state.contentType === entity_1.ContentType.PEER_REVIEW_CARD)
        .filter(state => state.completionStatus !== entity_1.CompletionStatus.COMPLETE)
        .map(state => state.contentId);
    let toCompleteContentIds;
    if (previousCourseCompletionStatus === entity_1.CompletionStatus.COMPLETE) {
        toCompleteContentIds = incompleteCardContentIds;
    }
    else {
        toCompleteContentIds = completedContentIds.filter(completedContentId => incompleteCardContentIds.indexOf(completedContentId));
    }
    return toCompleteContentIds;
}
exports.getToCompleteContentIds = getToCompleteContentIds;
//# sourceMappingURL=getToCompleteContentIds.js.map